import '@/page/homePage/views/index/homeImg'
